module.exports = __webpack_public_path__ + "img/projekweb3.2ab92cbb.png";